export class Ticket {
    topic: string = '';
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    subject: string = '';
    message: string = '';
    machineNumber: string = '';
    machinSernr: string = '';
    machinEqunr: string = '';
    machinText: string = '';
    languageCode: string = '';
    token: string = '';
    website: string = '';

    hasMultipleWords(): boolean {
        return (this.message?.trim().split(/\s+/).filter(word => word.length > 0).length ?? 0) > 1;
    }

    isFilled(): boolean {
        return (!!this.topic?.trim() && ((this.topic?.trim().startsWith('MP-') && !!this.machineNumber?.trim()) || !this.topic?.trim().startsWith('MP-'))) && !!this.firstName?.trim() && !!this.lastName?.trim()
            && !!this.email?.trim() && !!this.subject?.trim() && this.hasMultipleWords();
    }
}
